module.exports = __webpack_public_path__ + "static/media/logo_supplyDrop_dark.054b2555.svg";